export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const EXPIRED_TIME = 'expiredTime';
export const BREADCRUMB_NAME = 'breadcrumbName';
export const ID_CANDIDATE = 'idCandidate';

export enum CANDIDATE_STATUS {
  FAIL = 'FAIL',
  PASS = 'PASS_CV',
  CHECKING = 'CHECKING_CV',
  REJECT = 'REJECT'
}

export const getCandidateValue = (val: string) => {
  const candidateStatus: any = {
    FAIL: 'Fail',
    PASS: 'Pass',
    CHECKING_CV: 'Checking_CV',
    UNSATISFACTORY: 'Unsatisfactory',
    OFFER: 'Offer',
    WAITING_FOR_INTERVIEW: 'Waiting for interview'
  };
  if (val) return candidateStatus[val.toString()];
};

export const getCandidateValue2 = (val: string) => {
  const candidateStatus: any = {
    PENDING: 'Pending',
    PASS_CV: 'Pass CV',
    FAIL_CV: 'Fail CV',
    SCHEDULED_INTERVIEW: 'Shedule Interview',
    INTERVIEWED: 'Interviewed',
    PASS_INTERVIEW_ROUND_1: 'Pass Round 1',
    SCHEDULED_INTERVIEW_ROUND_2: 'Schedule Round 2',
    PASS_INTERVIEW: 'Pass Interview',
    FAIL_INTERVIEW: 'Fail Interview',
    REJECT: 'Reject'
  };
  if (val) return candidateStatus[val.toString()];
};

export enum CANDIDATE_STATUS_NEW {
  PASSED_BOD_INTERVIEW = 'PASSED_BOD_INTERVIEW',
  PENDING = 'PENDING',
  PASS_CV = 'PASS_CV',
  FAIL_CV = 'FAIL_CV',
  PASS_LEADER_REVIEW_CV ="PASS_LEADER_REVIEW_CV",
  FAILED_LEADER_REVIEW_CV="FAILED_LEADER_REVIEW_CV",
  SCHEDULED_INTERVIEW = 'SCHEDULED_INTERVIEW',
  INTERVIEWED = 'INTERVIEWED',
  PASS_INTERVIEW_ROUND_1 = 'PASS_INTERVIEW_ROUND_1',
  SCHEDULED_INTERVIEW_ROUND_2 = 'SCHEDULED_INTERVIEW_ROUND_2',
  PASS_INTERVIEW = 'PASS_INTERVIEW',
  FAIL_INTERVIEW = 'FAIL_INTERVIEW',
  REJECT = 'REJECT'
}

//Setup StepItem data for Candidate Process
export const stepItemCandidateInfo = [
  {
    'number': 1,
    'label': 'HR review',
  },
  {
    'number': 2,
    'label': 'Leader review',
  },
  {
    'number': 3,
    'label': 'Review the test',
  },
  {
    'number': 4,
    'label': 'Leader interview',
  },
  {
    'number': 5,
    'label': 'BOD interview',
  },
]

// Setup Status Candidate Evolution Process
export const stepItemCandidateEvolution = [
  {
    'number': 1,
    'label': 'HR review',
  },
  {
    'number': 2,
    'label': 'Leader review',
  },
  {
    'number': 3,
    'label': 'Leader interview',
  },
  {
    'number': 4,
    'label': 'BOD interview',
  },
]
export const stepItemCandidateInfoBOD = [
  {
    'number': 1,
    'label': 'Leader review',
  },
  {
    'number': 2,
    'label': 'Review the test',
  },
  {
    'number': 3,
    'label': 'Leader interview',
  },
  {
    'number': 4,
    'label': 'BOD interview',
  },
]